import { Component, Inject } from '@angular/core';
import { ICON } from '@core/util/icon';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';

@Component({
	selector: 'app-invalid-matter-type',
	templateUrl: './invalid-matter-type.component.html',
	imports: [AtomicModule],
})
export class InvalidMatterTypeComponent {
	protected readonly ICON = ICON;

	constructor(@Inject(MAT_DIALOG_DATA) protected matterTypeId: string) {}
}
